import { render, staticRenderFns } from "./Test12.vue?vue&type=template&id=19a64fa9&scoped=true&"
import script from "./Test12.vue?vue&type=script&lang=js&"
export * from "./Test12.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test12.vue?vue&type=style&index=1&id=19a64fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a64fa9",
  null
  
)

export default component.exports